import { FC, ReactNode } from 'react'
import { useLocation } from 'react-router'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

import { defaultThemeDark } from './themes/defaultDark'
import { defaultThemeLight } from './themes/defaultLight'
import { getIsStreamManager } from './utils'

import { useRoutes } from './store'

type Props = {
  children: ReactNode
  isLoggedIn?: boolean
}

export const ThemeSwitcher: FC<Props> = ({ children, isLoggedIn }) => {
  const { pathname } = useLocation()
  const routes = useRoutes()
  const currentTheme = isLoggedIn && getIsStreamManager(pathname, routes) ? defaultThemeLight : defaultThemeDark
  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  )
}

export default ThemeSwitcher
